import React from 'react';
import { Col } from 'antd';
import Card from 'app/components/Card';
import { Paragraph } from 'app/components/Typography/Paragraph';
import { DescriptionFields } from './constants';
import styled from '@emotion/styled';
import StyledInfo from '../StyledInfo';
import { Status } from 'app/modules/ui';
import Icon from '@ant-design/icons';
import { ReactComponent as AlarmIcon } from 'assets/icons/alarm.svg';
import { DateCell } from 'app/components/Table/Cells/DateCell';
import classes from './styles.module.scss';

type Props = {
  // data: {};
  loading: boolean;
  data: {
    generalInspectLevel: string;
    inspectionDate: string;
    typeOfService: string;
    updatedAt: string;
    createdAt: string;
  };
};
const StyledCard = styled(Card)`
  height: 100%;
  background: #fff;
  overflow: auto;
  padding-bottom: 16px;
`;
const InspectionRequirement = ({ loading, data }: Props) => {
  return (
    <StyledCard
      bordered={false}
      title={
        <>
          Inspection Requirements
          <Status className={classes.dateUpdated} color="processing" type="tag">
            <span className={classes.wrapper}>
              <Icon component={AlarmIcon}></Icon>
              <span className={classes.dateUpdatedText}>
                Date Updated:
                <DateCell
                  value={data?.updatedAt}
                  format="DD MMM YYYY, HH:mm"
                ></DateCell>
              </span>
            </span>
          </Status>
        </>
      }
      loading={loading}
    >
      {DescriptionFields.map(
        ({ name, format, label, render, defaultValue }: any, index) => {
          const value = (data as any)[name] || defaultValue;
          return (
            <StyledInfo key={index}>
              <Col span={12}>{label}</Col>
              <Col span={12}>
                {render ? (
                  render(data)
                ) : (
                  <Paragraph>{format ? format(value) : value}</Paragraph>
                )}
              </Col>
            </StyledInfo>
          );
        }
      )}
    </StyledCard>
  );
};

export default InspectionRequirement;
